import { motion, usePresenceData } from "motion/react";
import React, { useRef } from "react";

type Props = React.ComponentProps<typeof motion.div>;

export function RevealMotion({ children, style, ...props }: Props) {
  const initialRender = usePresenceData() as boolean;
  const ref = useRef<HTMLDivElement | null>(null);

  const onAnimationStart = () => {
    if (ref.current) {
      ref.current.style.overflow = "hidden";
    }
  };
  const onAnimationEnd = (def: { height: string | number }) => {
    if (ref.current && def.height === "auto") {
      ref.current.style.overflow = "visible";
    }
  };

  return (
    <motion.div
      ref={ref}
      initial={initialRender ? false : { height: 0 }}
      animate={{ height: "auto" }}
      exit={{ height: 0 }}
      style={style}
      onAnimationStart={onAnimationStart}
      onAnimationComplete={onAnimationEnd}
      {...props}
    >
      {children}
    </motion.div>
  );
}
